import Vue from 'vue'
import NativeApi from 'native-api'
import { parseQueryString } from '@/util/common'
import { Dialog } from '@guazi-fe/melon'
import browser from '@/util/browser'

export const mixin = Vue.mixin({
    data() {
        return {
            // 问卷调查tid：D29038E2-61D9-4937-B7AA-0BD0784B653F
            // 云平台管理tid：6D73B1E4-B0C6-4105-BB77-717ABC012345
            tid: parseQueryString().tid,
            isSuperAdmin: parseQueryString().tid === '6D73B1E4-B0C6-4105-BB77-717ABC012345',
        }
    },
    mounted() {
        const { guaguaApp: isGUAGUA } = browser
        if (isGUAGUA) {
            // 去掉右上角...中的发送给呱呱同事及关闭按钮
            let params = {
                menu: [
                    {
                        name: 'send_to_guagua',
                        click: '9',
                    },
                ],
            }
            NativeApi.invoke('removeWebTools', params)
        }

        // NativeApi.invoke('hiddenCloseBtn', {hiddenClose: 1})
    },
    methods: {
        $_push(name, pageId) {
            this.$router.push({
                name: name,
                params: {
                    pageId: pageId,
                },
            })
        },
        $_dialog(options = {}, cxt = this) {
            const {
                title,
                message,
                confirmFn = () => {},
                cancelFn = () => {},
            } = options
            Dialog.confirm({
                title: title || '提示',
                message: message || '',
            })
                .then(() => {
                // on confirm
                    confirmFn.call(cxt)
                })
                .catch(() => {
                    cancelFn.call(cxt)
                // on cancel
                })
        },
    },
})

